<template>
  <div class="card mb-4">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h2 class="pull-left">Transacties</h2>
      <form class="form-inline pull-right">
        <select v-model="parentYear" name="year" id="year" class="form-control" aria-label="Kies jaar">
          <option v-for="(transaction, year) in transactions" :key="year" :value="year">{{ year }}</option>
        </select>
      </form>
    </div>
    <div class="card-body">
      <mijn-betalingen-chart :chart-data-prop="transactions" :parent-year="parentYear" :width="100" :height="55"></mijn-betalingen-chart>
    </div>
  </div>
</template>

<script>
import MijnBetalingenChart from "./MijnBetalingenChart";

export default {
    components: {MijnBetalingenChart},
    props: {
        transactions: Object,
    },
    data() {
       return {
           parentYear: Object.keys(this.transactions).slice(-1)[0],
       }
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/components/MijnBetalingen.vue